var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { hideApplicationLoader } from 'common/ApplicationLoader';
import { showToast } from 'common/Toast';
import { API } from 'globals/api';
import { ALERTS_DASHBOARD_END_POINTS } from 'globals/apiEndPoints';
import get from 'lodash.get';
import { GET_ALERTS_DASHBOARD, GET_ALERTS_DASHBOARD_SUCCESS, GET_ALERTS_DASHBOARD_FAILURE, UPDATE_ALERTS_DASHBOARD_PAGE_NUMBER, GET_ALERTS_DEVICES, GET_ALERTS_DEVICES_FAILURE, GET_ALERTS_DEVICES_SUCCESS, GET_ALERTS_SOS, GET_ALERTS_SOS_SUCCESS, GET_ALERTS_SOS_FAILURE, } from './components/AlertsDashboard.types';
import { Roles } from 'globals/enums';
import { getCareAgentInfo } from 'globals/global.functions';
import { getClientTimezone } from 'globals/date.functions';
import { showError } from 'store/commonReducer/common.action';
// Helper function to get user role and facility_id
var getUserRoleAndFacilityId = function (getState) {
    var state = getState ? getState() : {};
    var userRole = get(state, 'auth.user.role', '');
    var facilityId = get(state, 'auth.user.facility_id', '');
    return { userRole: userRole, facilityId: facilityId };
};
// -----------------------------
// Fetch seniors for Alerts Dashboard
// -----------------------------
export var getAlertsDashboard = function (additional_params, allSeniorsChecked, timeFrame) {
    if (timeFrame === void 0) { timeFrame = 'day'; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var seniorsData, facilityId, faciltyType, careAgentId, userRole, apiParams, hasLastEvaluatedKey, url, res, dashboardObj, transformedSeniors, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    seniorsData = getState().alertsDashboard.seniorsData;
                    dispatch({ type: GET_ALERTS_DASHBOARD });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    facilityId = getCareAgentInfo().facility_info.facility_id;
                    faciltyType = getCareAgentInfo().facility_info.facility_type;
                    careAgentId = getCareAgentInfo().userId;
                    userRole = getState().auth.roleConfig.role;
                    apiParams = __assign(__assign({}, additional_params), { ascending: true, timezone: getClientTimezone() });
                    hasLastEvaluatedKey = !!apiParams.last_evaluated_key;
                    if (!hasLastEvaluatedKey)
                        delete apiParams.last_evaluated_key;
                    url = getState().router.location.pathname;
                    if ((userRole === Roles.Admin ||
                        userRole === Roles.Admin_WellnessServices) &&
                        url.includes('facilityCare')) {
                        apiParams.facility_id = url.split('/')[2];
                    }
                    if (userRole === Roles.FACILITY_AGENT && facilityId) {
                        apiParams.facility_id = facilityId;
                        apiParams.facility_type = faciltyType;
                    }
                    if (userRole === Roles.CareAgent && careAgentId && !allSeniorsChecked) {
                        apiParams.assigned_to = careAgentId;
                    }
                    return [4 /*yield*/, API({
                            url: ALERTS_DASHBOARD_END_POINTS.GET_ALERTS_DASHBOARD,
                            method: 'get',
                            params: apiParams,
                        })];
                case 2:
                    res = _a.sent();
                    dashboardObj = timeFrame === 'day'
                        ? get(res, 'data.current_dashboard', {})
                        : get(res, 'data.dashboard', {});
                    transformedSeniors = Object.entries(dashboardObj).map(function (_a) {
                        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
                        var seniorId = _a[0], senior = _a[1];
                        var firstName = get(senior, 'name.first_name', '');
                        var lastName = get(senior, 'name.last_name', '');
                        var fullName = "".concat(firstName, " ").concat(lastName).trim();
                        var memberId = senior.member_id;
                        return {
                            seniorId: seniorId,
                            seniorName: memberId ? "".concat(fullName, " (").concat(memberId, ")") : fullName,
                            is_profile_paused: (_b = senior.is_profile_paused) !== null && _b !== void 0 ? _b : false,
                            profile: {
                                account_id: senior.account_id,
                                member_id: memberId,
                                image: senior.profile_image || null,
                            },
                            location: {
                                timezone: get(senior, 'location.timezone'),
                            },
                            devices: __assign(__assign({}, senior.devices), { watch: __assign(__assign({}, (_c = senior.devices) === null || _c === void 0 ? void 0 : _c.watch), { heart_rate: timeFrame === 'day'
                                        ? (_e = (_d = senior.devices) === null || _d === void 0 ? void 0 : _d.watch) === null || _e === void 0 ? void 0 : _e.current_heart_rate
                                        : (_g = (_f = senior.devices) === null || _f === void 0 ? void 0 : _f.watch) === null || _g === void 0 ? void 0 : _g.heart_rate, heart_category: timeFrame === 'day'
                                        ? (_j = (_h = senior.devices) === null || _h === void 0 ? void 0 : _h.watch) === null || _j === void 0 ? void 0 : _j.current_heart_category
                                        : (_l = (_k = senior.devices) === null || _k === void 0 ? void 0 : _k.watch) === null || _l === void 0 ? void 0 : _l.heart_category, current_heart_rate: (_o = (_m = senior.devices) === null || _m === void 0 ? void 0 : _m.watch) === null || _o === void 0 ? void 0 : _o.current_heart_rate, current_heart_category: (_q = (_p = senior.devices) === null || _p === void 0 ? void 0 : _p.watch) === null || _q === void 0 ? void 0 : _q.current_heart_category, activity_category: get(senior, 'devices.watch.activity_category', null), avg_activity_score: get(senior, 'devices.watch.avg_activity_score', null) }) }),
                            alerts: senior.alerts || {},
                            risk_category: timeFrame === 'day'
                                ? (_r = senior.current_category) !== null && _r !== void 0 ? _r : null
                                : (_s = senior.risk_category) !== null && _s !== void 0 ? _s : null,
                            current_category: (_t = senior.current_category) !== null && _t !== void 0 ? _t : null,
                            current_category_score: timeFrame === 'day'
                                ? (_u = senior.current_category_score) !== null && _u !== void 0 ? _u : null
                                : (_v = senior.category_score) !== null && _v !== void 0 ? _v : null,
                            category_score: (_w = senior.category_score) !== null && _w !== void 0 ? _w : null,
                            device_status: senior.device_status || {},
                        };
                    });
                    if (userRole === Roles.CareAgent &&
                        (!transformedSeniors || transformedSeniors.length === 0) &&
                        !allSeniorsChecked) {
                        return [2 /*return*/, { forcedAllSeniors: true }];
                    }
                    if (hasLastEvaluatedKey)
                        transformedSeniors = __spreadArray(__spreadArray([], seniorsData, true), transformedSeniors, true);
                    dispatch({
                        type: GET_ALERTS_DASHBOARD_SUCCESS,
                        payload: {
                            seniorsData: transformedSeniors,
                            lastEvaluatedKey: get(res, 'data.LastEvaluatedKey', {}),
                        },
                    });
                    return [2 /*return*/, transformedSeniors];
                case 3:
                    error_1 = _a.sent();
                    dispatch({ type: GET_ALERTS_DASHBOARD_FAILURE, payload: 'Fetching seniors failed.' });
                    dispatch(showError(error_1));
                    return [2 /*return*/, []];
                case 4:
                    dispatch(hideApplicationLoader());
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
// -----------------------------
// Fetch devices data for Alerts Dashboard
// -----------------------------
export var getAlertsDevices = function () {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, userRole, facilityId, apiParams, res, devicesData, devicesSummary, online, offline, total, err_1, message;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch({ type: GET_ALERTS_DEVICES });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    _a = getUserRoleAndFacilityId(getState), userRole = _a.userRole, facilityId = _a.facilityId;
                    apiParams = {};
                    if (userRole === Roles.FACILITY_AGENT && facilityId) {
                        apiParams.facility_id = facilityId;
                    }
                    return [4 /*yield*/, API({
                            url: ALERTS_DASHBOARD_END_POINTS.GET_ALERTS_DEVICES,
                            method: 'get',
                            params: Object.keys(apiParams).length > 0 ? apiParams : undefined,
                        })];
                case 2:
                    res = _b.sent();
                    devicesData = get(res, 'data', {});
                    devicesSummary = {};
                    if (devicesData.Techuva) {
                        online = devicesData.Techuva.online || 0;
                        offline = devicesData.Techuva.offline || 0;
                        total = online + offline;
                        devicesSummary.Techuva = {
                            online: online,
                            offline: offline,
                            percentage: total > 0 ? Math.round((online / total) * 100) : 0,
                        };
                    }
                    if (devicesData.Navigil) {
                        devicesSummary.Navigil = {
                            count: devicesData.Navigil.count || 0,
                        };
                    }
                    dispatch({
                        type: GET_ALERTS_DEVICES_SUCCESS,
                        payload: devicesSummary,
                    });
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, devicesSummary];
                case 3:
                    err_1 = _b.sent();
                    dispatch(hideApplicationLoader());
                    message = err_1.message ||
                        get(err_1, 'response.data.message', 'Fetch devices failed.');
                    dispatch({ type: GET_ALERTS_DEVICES_FAILURE, payload: message });
                    dispatch(showToast(message, 'error'));
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
// -----------------------------
// Fetch SOS & Falls data
// -----------------------------
export var getAlertsSOS = function (payload) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, userRole, facilityId, apiPayload, res, sosFallsData, err_2, message;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch({ type: GET_ALERTS_SOS });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    _a = getUserRoleAndFacilityId(getState), userRole = _a.userRole, facilityId = _a.facilityId;
                    apiPayload = __assign({}, payload);
                    if (userRole === Roles.FACILITY_AGENT && facilityId) {
                        apiPayload.facility_id = facilityId;
                    }
                    return [4 /*yield*/, API({
                            url: ALERTS_DASHBOARD_END_POINTS.POST_ALERTS_SOS,
                            method: 'post',
                            data: apiPayload,
                        })];
                case 2:
                    res = _b.sent();
                    sosFallsData = get(res, 'data.total', { sos: 0, falls: 0 });
                    dispatch({
                        type: GET_ALERTS_SOS_SUCCESS,
                        payload: sosFallsData,
                    });
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, sosFallsData];
                case 3:
                    err_2 = _b.sent();
                    dispatch(hideApplicationLoader());
                    message = err_2.message ||
                        get(err_2, 'response.data.message', 'Fetch SOS/Falls failed.');
                    dispatch({ type: GET_ALERTS_SOS_FAILURE, payload: message });
                    dispatch(showToast(message, 'error'));
                    return [2 /*return*/, { sos: 0, falls: 0 }];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
// -----------------------------
// Fetch Senior Count Data
// -----------------------------
export var getAlertsSeniorCount = function () {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, userRole, facilityId, apiParams, res, seniorCountData, err_3, message;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = getUserRoleAndFacilityId(getState), userRole = _a.userRole, facilityId = _a.facilityId;
                    apiParams = {};
                    if (userRole === Roles.FACILITY_AGENT && facilityId) {
                        apiParams.facility_id = facilityId;
                    }
                    return [4 /*yield*/, API({
                            url: ALERTS_DASHBOARD_END_POINTS.GET_ALERTS_SENIORCOUNT,
                            method: 'get',
                            params: Object.keys(apiParams).length > 0 ? apiParams : undefined,
                        })];
                case 1:
                    res = _b.sent();
                    seniorCountData = get(res, 'data', {
                        total_members_monitored: 0,
                        members_assigned_per_coach_avg: 0,
                    });
                    return [2 /*return*/, seniorCountData];
                case 2:
                    err_3 = _b.sent();
                    message = err_3.message ||
                        get(err_3, 'response.data.message', 'Fetch senior count failed.');
                    dispatch(showToast(message, 'error'));
                    return [2 /*return*/, {
                            total_members_monitored: 0,
                            members_assigned_per_coach_avg: 0,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
// -----------------------------
// Fetch Senior Device Info Data
// -----------------------------
export var getAlertsSeniorDeviceInfo = function (params) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, userRole, facilityId, apiParams, res, seniorDeviceInfo, err_4, message;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = getUserRoleAndFacilityId(getState), userRole = _a.userRole, facilityId = _a.facilityId;
                    apiParams = __assign(__assign({}, params), { ascending: true });
                    if (userRole === Roles.FACILITY_AGENT && facilityId) {
                        apiParams.facility_id = facilityId;
                    }
                    return [4 /*yield*/, API({
                            url: ALERTS_DASHBOARD_END_POINTS.GET_ALERTS_SENIORDEVICEINFO,
                            method: 'get',
                            params: apiParams,
                        })];
                case 1:
                    res = _b.sent();
                    seniorDeviceInfo = get(res, 'data.overall', {
                        overall_avg_heart_rate: 0,
                        overall_avg_step_count: 0,
                        overall_avg_sleep_score: 0,
                    });
                    return [2 /*return*/, seniorDeviceInfo];
                case 2:
                    err_4 = _b.sent();
                    message = err_4.message ||
                        get(err_4, 'response.data.message', 'Fetch senior device info failed.');
                    dispatch(showToast(message, 'error'));
                    return [2 /*return*/, {
                            overall_avg_heart_rate: 0,
                            overall_avg_step_count: 0,
                            overall_avg_sleep_score: 0,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
// -----------------------------
// Update current page number in dashboard pagination
// -----------------------------
export var updateAlertsDashboardPageNumber = function (pageNumber) { return ({
    type: UPDATE_ALERTS_DASHBOARD_PAGE_NUMBER,
    payload: pageNumber,
}); };
